<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader.vue";

export default {
  page: {
    title: "Extre",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  }, 
  components: {
    Layout,
    PageHeader,
    Loader
  },
  data() {
    return {
        list: {},
        title: "EXTRE RAPORU",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "EXTRE RAPORU",
            active: true,
          },
        ],
        isLoading: true,
        detailSearch:false,
        form:{},
        odemeAlDetay:{},
        rows: [],
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        url: "/dealers/null/balances",
        totalData:{},
        totalDataLoading:true,
        rowsLoading:true,
    };
  },
   mounted() {
    this.date()
    this.loadItems()
    this.getTotal()
  },
  methods: {
    date(){
        var currentDate = new Date();
        var firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        var lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        this.form.startdate= this.formatDate(firstDay),
        this.form.startdateend= this.formatDate(lastDay)
    },

    formatDate(date) {
        var day = date.getDate();
        var month = date.getMonth() + 1; // JavaScript'te aylar 0'dan başlar, bu yüzden +1 ekliyoruz
        var year = date.getFullYear();

        // Gerekirse, gün ve ayı iki haneli yapmak için sıfır ekleyebilirsiniz
        day = day < 10 ? '0' + day : day;
        month = month < 10 ? '0' + month : month;
        
        return year + '-' + month + '-' + day;
    },
  
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },

    getTotal(){
      this.$http.post(`/dealers/null/balances/total`, this.serverParams)
            .then(response => {
              this.totalData = response.data
              this.totalDataLoading = false
            })

    },
   
    loadItems() {
      this.$http.post(this.url, this.serverParams)
            .then(response =>{
               this.rows = response.data
               this.rowsLoading = false
            })
    },

    formSubmit() {
      this.updateParams({ columnFilters : this.form})
      this.loadItems()
      this.totalDataLoading = true
      this.rowsLoading = true
      this.getTotal()
    },

    detay(props){
       this.odemeAlDetay = props
       this.$parent.$bvModal.show('odeme_al')
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <Loader :loading="true" :load="totalDataLoading">
                <div class="col-lg-12 align-self-center">
                  <div class="text-lg-center mt-4 mt-lg-0">
                    <div class="row">
                      <div class="col-3">
                        <div>
                          <p class="text-muted text-truncate mb-2"> Satış Toplamı</p>
                          <h5 class="mb-0" style="padding: 8px;">{{ $paraFormat(totalData.borc) }}</h5>
                        </div>
                      </div>
                      <div class="col-3">
                        <div>
                          <p class="text-muted text-truncate mb-2"> Komisyon Toplamı</p>
                          <h5 class="mb-0" style="padding: 8px;">{{ $paraFormat(totalData.commission) }}</h5>
                        </div>
                      </div>
                      <div class="col-3">
                        <div>
                          <p class="text-muted text-truncate mb-2"> Tahsilat Toplamı</p>
                          <h5 class="mb-0" style="padding: 8px;">{{ $paraFormat(totalData.collect) }}</h5>
                        </div>
                      </div>
                      <div class="col-3">
                        <div>
                          <p class="text-muted text-truncate mb-2"> Bakiye Toplamı</p>
                          <h5 class="mb-0" style="padding: 8px;">{{ $paraFormat(totalData.balance) }}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Loader>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <form class="needs-validation" @submit.prevent="formSubmit">
              <div class="row">
                <div class="col-xl-8">
                    <div class="row">
                        <div class="col-md-12">
                            <label class="d-flex justify-content-between">Tarih Aralığı
                            <span 
                                v-if="form.startdate || form.startdateend" 
                                class="text-danger" 
                                @click="form.startdate= '' ;form.startdateend= ''">
                                temizle</span>
                            </label>
                            <div class="input-group">
                            <input type="date" class="form-control"  v-model="form['startdate']">
                            <button style="border:0;background: transparent;">  - </button>
                            <input type="date" class="form-control"  v-model="form['startdateend']">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4">
                  <div class="row">
                    <div class="col-md-12">
                      <label>-</label>
                      <div class="button-items">
                          <button 
                            type="submit"
                            class="btn btn-primary w-100 "   
                            >
                            Sorgula
                          </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
              <!-- end card -->
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <div class="row">      
      <div class="col-12">
        <Loader :loading="true" :load="rowsLoading">
          <div class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Ödemeyi Alan</th>
                                <th>İşlem Tarihi</th>
                                <th>Kullanıcı Adı</th>
                                <th>İsim Soyisim</th>
                                <th>Açıklama</th>
                                <th>Satış</th>
                                <th>Komisyon</th>
                                <th>Tahsilat</th>
                                <th>Bakiye</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="rows.length == 0">
                              <td colspan="9" class="text-center">Kayıt Bulunamadı</td>
                            </tr>
                            <tr v-for="(row,i) in rows" :key="i">
                                <td>{{ row.user_name }}</td>
                                <td>{{ row.transaction_date }}</td>
                                <td>{{ row.username }}</td>
                                <td>{{ row.fname }} {{ row.lname }}</td>
                                <td>{{ row.main_explaine }}</td>
                                <td>{{ $paraFormat(row.borc) }}</td>
                                <td>{{ $paraFormat(row.commission) }}</td>
                                <td>{{ $paraFormat(row.collect) }}</td>
                                <td>{{ $paraFormat(row.balance) }}</td>
                            </tr>
                        </tbody>
                    </table>    
                </div>  
            </div>
          </div>
        </Loader>  
      </div>
    </div>
  </Layout>
</template>